import React from "react";
import TodoApp from "./components/ToDoApp";

function App() {
  return (
    <div>
      <TodoApp />
    </div>
  );
}

export default App;
